import { css } from 'react-emotion'

const styles = {
  modalContent: css({
    padding: '0 !important'
  }),
  videoDescriptionModal: css({
    display: 'flex !important',
    alignItems: 'center',
    padding: '1.5rem'
  }),
  videoImageModal: css({
    marginRight: '16px'
  }),
  uploadParameters: css({
    backgroundColor: 'rgb(245, 246, 250)',
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem',
    marginTop: '24px',
    borderTop: '1px solid rgba(34,36,38,.15)',
    '& > div + div': {
      margin: '16px 0'
    }
  }),
  uploadParameterInput: css({
    width: '100%',
    '& > .input': {
      width: '100%'
    }
  }),
  label: css({
    fontSize: '1em',
    paddingLeft: '2px',
    paddingBottom: '2px',
    fontWeight: 'bold'
  }),
  title: css({
    fontSize: '14px'
  }),
  user: css({
    color: '#999',
    fontSize: '12px'
  }),
  dot: css({
    marginRight: '4px',
    marginLeft: '4px',
    fontSize: '14px',
    color: '#999'
  }),
  date: css({
    fontSize: '12px',
    color: '#999'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/UploadToDrive/UploadToJwStyles.js